import React, { useState, useContext } from 'react';
import { RicosContext, ModalContext, EditorContext } from 'ricos-context';
import { ToggleButton } from 'wix-rich-content-toolbars-ui';
import { HTML_BUTTONS } from '../consts.js';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DimensionSliderButton = ({
  toolbarItem,
  dimension,
  dataHook,
  min,
  max,
  defaultValue
}) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const { t } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext);
  const { icon, tooltip } = toolbarItem.presentation;
  const node = toolbarItem.attributes.selectedNode;
  const { getEditorCommands } = useContext(EditorContext);
  const getComponentData = () => {
    const nodeId = node == null ? void 0 : node.attrs.id;
    return getEditorCommands().getBlockComponentData(nodeId) || {};
  };
  const getValue = () => {
    var _a, _b;
    return (_b = (_a = getComponentData().containerData) == null ? void 0 : _a[dimension]) == null ? void 0 : _b.custom;
  };
  const onChange = (value) => {
    const componentData = getComponentData();
    const containerData = __spreadProps(__spreadValues({}, componentData.containerData), {
      [dimension]: {
        custom: value
      }
    });
    setTimeout(() => {
      var _a;
      (_a = toolbarItem.commands) == null ? void 0 : _a.click({ value, data: __spreadProps(__spreadValues({}, componentData), { containerData }) });
    }, 0);
  };
  const onClick = () => {
    if (modalService == null ? void 0 : modalService.isModalOpen(HTML_BUTTONS[dimension])) {
      modalService.closeModal(HTML_BUTTONS[dimension]);
    } else {
      const componentProps = {
        onChange,
        min,
        max,
        value: getValue() || defaultValue
      };
      modalService.openModal(HTML_BUTTONS[dimension], {
        componentProps,
        layout: "popover",
        positioning: { referenceElement, placement: "bottom" }
      });
    }
  };
  return /* @__PURE__ */ React.createElement("div", { ref: setReferenceElement }, /* @__PURE__ */ React.createElement(ToggleButton, { Icon: icon, onClick, dataHook, tooltip: t(tooltip) }));
};

export { DimensionSliderButton };
//# sourceMappingURL=DimensionSliderButton.js.map
